// TYPES
import { RootState } from '@/types/store';

export const getUser = ({ auth }: RootState): NonNullable<RootState['auth']>['user'] =>
  auth?.user || ({} as NonNullable<RootState['auth']>['user']);

export const getPartner = ({ auth }: RootState): NonNullable<RootState['auth']>['partner'] =>
  auth?.partner || {};

export default {
  getUser,
  getPartner,
};
